import { render, staticRenderFns } from "./NonConformitiesTable.vue?vue&type=template&id=5f4790aa&scoped=true&"
import script from "./NonConformitiesTable.vue?vue&type=script&lang=js&"
export * from "./NonConformitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./NonConformitiesTable.vue?vue&type=style&index=0&id=5f4790aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4790aa",
  null
  
)

export default component.exports